import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Card, Collapse } from "react-bootstrap";
import filterTypes from "data/filter-types";
import findFilterValue from "helpers/find-filter-value";
import FilterItem from "views/lib/components/filter/filter-item";
import FilterHeader from "views/lib/components/filter/filter-header";
import {
    getFilters,
} from "actions/reports/actions";

class Filters extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            filters: {
                start: this.props.activeFilters[0],
                end: this.props.activeFilters[1]
            }
        };

        this.handleSearch = this.handleSearch.bind(this);
        this.handleChangeFilter = this.handleChangeFilter.bind(this);

        this.props.getFilters();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.totalCount !== this.props.totalCount) {
            return true;
        } else if (nextState.isOpen !== this.state.isOpen) {
            return true;
        } else if (!_.isEqual(nextState.filters, this.state.filters)) {
            return true;
        } else if (!_.isEqual(nextProps.activeFilters, this.props.activeFilters)) {
            return true;
        }
        return false;
    }

    handleSearch = () => {
        const { filters } = this.state;
        const filtersToArray = [];
        Object.keys(filters).forEach(name => {
            if (Object.keys(filters[name]).length) {
                filtersToArray.push(filters[name]);
            }
        });
        this.props.handleSearch(filtersToArray);
    };

    handleChangeFilter = (name, valueObject) => {
        const { filters } = this.state;
        filters[name] = valueObject;
        this.setState({
            filters
        });
    };

    render() {
        const { activeFilters, totalCount } = this.props;
        const { isOpen } = this.state;

        return (
            <Card className="w-100 mb-2 rounded-0">
                <FilterHeader
                    title="Daily Range Reports"
                    totalCount={totalCount}
                    isOpen={isOpen}
                    onToggle={status => this.setState({ isOpen: status })}
                />
                <Card.Body className="p-0">
                    <Collapse in={isOpen} className="p-3" timeout={0}>
                        <div className="row">
                            <div className="col-12 col-md-3 mb-3">
                                <FilterItem
                                    name="start"
                                    placeholder="Start"
                                    filterType="date"
                                    onChange={this.handleChangeFilter}
                                    searchOperation={[filterTypes.MORE.value]}
                                    value={findFilterValue("start", activeFilters)}
                                />
                            </div>
                            <div className="col-12 col-md-3 mb-3">
                                <FilterItem
                                    name="end"
                                    placeholder="End"
                                    filterType="date"
                                    onChange={this.handleChangeFilter}
                                    searchOperation={[filterTypes.LESS.value]}
                                    value={findFilterValue("end", activeFilters)}
                                />
                            </div>

                            <div className="col-12 col-md-3 mb-3 offset-3">
                                <div className="d-flex justify-content-between justify-content-md-end">
                                    <button
                                        className="btn btn-success btn-sm ml-2"
                                        onClick={this.handleSearch}
                                    >
                                        Load
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                </Card.Body>
            </Card>
        );
    }
}

Filters.defaultProps = {
    activeFilters: []
};

Filters.propTypes = {
    activeFilters: PropTypes.array.isRequired,
    handleSearch: PropTypes.func.isRequired,
    totalCount: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
    allFilters: state.reports.allFilters,
});

const mapStateToDispatch = dispatch => ({
    getFilters: bindActionCreators(getFilters, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(Filters);



// WEBPACK FOOTER //
// ./src/views/pages/reports/daily-range-filters.js